import { render, staticRenderFns } from "./back.vue?vue&type=template&id=5249ca52&scoped=true"
import script from "./back.vue?vue&type=script&lang=js"
export * from "./back.vue?vue&type=script&lang=js"
import style0 from "./back.vue?vue&type=style&index=0&id=5249ca52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5249ca52",
  null
  
)

export default component.exports